import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PluginOnTextLayerRender } from 'core/types'
import { Match, MatchPosition, NormalizedKeyword, SingleKeyword } from 'core/types/SearchType'

interface searchType {
  isSearch: boolean
  initialKeyword: SingleKeyword[]
  keyword?: NormalizedKeyword[]
  matchPosition: MatchPosition
  renderStatus: Map<number, PluginOnTextLayerRender>,
  pageMatchSearch: Match[]
}

const initialState: searchType = {
  isSearch: false,
  initialKeyword: [],
  keyword: [],
  matchPosition: {
    matchIndex: -1,
    pageIndex: -1
  },
  renderStatus: new Map<number, PluginOnTextLayerRender>(),
  pageMatchSearch: []
}

export const searchTextPdfSlice = createSlice({
  name: 'search_pdf',
  initialState,
  reducers: {
    setStatusSearch: (state, action: PayloadAction<boolean>) => {
      state.isSearch = action.payload
    },
    setMatchPosition: (state, action: PayloadAction<MatchPosition>) => {
      state.matchPosition = action.payload
    },
    setKeyWord: (state, action: PayloadAction<NormalizedKeyword[]>) => {
      state.keyword = action.payload
    },
    setRenderStatus: (state, action: PayloadAction<any>) => {
      state.renderStatus = action.payload
    },
    setPageMatchSearch: (state, action: PayloadAction<Match[]>) => {
      state.pageMatchSearch = action.payload
    }
  }
})
export const { setMatchPosition, setKeyWord, setStatusSearch, setRenderStatus, setPageMatchSearch } = searchTextPdfSlice.actions
export default searchTextPdfSlice.reducer
